import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ShowEventOnMainPage } from '../Partials/Helper';
import { requestGet } from '../../api/request';
import * as actions from '../../redux/actions';
import { HOME_EVENT } from '../../api/url';

const EvMissives = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loader, setLoader] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  const [event, setEvent] = useState([]);
  const [selectedSearchByDate, setSelectedSearchByDate] = useState(searchParams.get('date') || null);

  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const currentLanguage = useSelector(
    (state) => state.languageReducer.current_language,
  );
  const fontSize = useSelector((state) => state.fontSizeReducer.font_size);

  const getData = async () => {
    setLoader(true);

    const response = await requestGet(HOME_EVENT, {
      'event_type': 'missives',
      'searchByDate': selectedSearchByDate,
      'lang_id': currentLanguage.id,
    });

    if (response.success) {
      setEvent(response.data);
      setLoader(false);
    }
  };

  useEffect(() => {
    // Handle date url params;
    if (searchParams.get('date')) {
      setSelectedSearchByDate(searchParams.get('date'));
    } else {
      setSelectedSearchByDate(null);
      setSearchParams('');
    }
  }, [searchParams]);

  useEffect(() => {
    getData();
  }, [selectedSearchByDate, currentLanguage]);

  useEffect(() => {
    if (event.length > 0) {
      dispatch(actions.adjustFontSize(fontSize));
    }
  });

  return (
    <div className="tab-content" id="myTabContent">
      {loader === true ? (
        <div className="row d-flex justify-content-md-center align-items-center mt-3 mb-3">
          <div className="spinner-border text-success" role="status">
            <span className="sr-only" />
          </div>
        </div>
      ) : null}
      {event.length > 0 ? (
        <div
          className="tab-pane fade show active"
          id="missives"
          role="tabpanel"
          aria-labelledby="missives-tab"
        >
          <div className="row">
            <ShowEventOnMainPage event={event} type="missives" />
          </div>
          <div className="main-tab__button">
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event/missives');
              }}
              href="/event/missives"
              className="button button-update"
            >
              {dictionary.more}
            </a>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default EvMissives;
